import styled from "@emotion/styled";
import { GrDialog, GrDialogProps, GrTypography } from "@jnpmedi/grebob";
import { isMobileDevice, MvnMessage } from "@newLibs/utils";
import { UseBoolean } from "@newHooks/common/useBoolean";
import { DOCS_DOCUMENT_LANG, DOCS_FOLDER_LANG } from "@maven-msg/lang/docs";
import { DocumentSignType } from "@maven-rest/docs/DocumentSign.dto";

interface SignAgreementDialogProps {
  documentSignType: DocumentSignType;
  open: UseBoolean;
  size?: GrDialogProps["size"];
  onConfirm: () => void;
  isLoading: boolean;
}

export function SignAgreementDialog({ documentSignType, open, size = "xs", onConfirm, isLoading }: SignAgreementDialogProps) {
  return (
    <GrDialog
      title={MvnMessage(
        documentSignType === DocumentSignType.EConsent
          ? DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_DIALOG_HEADER
          : DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_HEADER
      )}
      open={open.value}
      preventCloseOnOutsideClick
      size={isMobileDevice() ? "mobile" : size}
      onClose={open.onFalse}
      onConfirm={onConfirm}
      cancelButton={{ children: MvnMessage(DOCS_FOLDER_LANG.DOCS_FOLDER_COMMON_CANCEL_NOUN), disabled: isLoading }}
      confirmButton={{ children: MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_AGREE_AND_PROCEED), isLoading }}
    >
      <AgreementWrapper>
        <li>
          <GrTypography type="Content.Body03" color="grey070">
            {MvnMessage(
              documentSignType === DocumentSignType.EConsent
                ? DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_DIALOG_AGREEMENT_EFFECT
                : DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_AGREEMENT_EFFECT
            )}
          </GrTypography>
        </li>
        <li>
          <GrTypography type="Content.Body03" color="grey070">
            {MvnMessage(
              documentSignType === DocumentSignType.EConsent
                ? DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ORIGINAL
                : DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_AGREEMENT_ORIGINAL
            )}
          </GrTypography>
        </li>
        <li>
          <GrTypography type="Content.Body03" color="grey070">
            {MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_PREFIX)}
            <a href="https://mvn.do/legal/agreement/esign" target="_blank" rel="noreferrer">
              {MvnMessage(
                documentSignType === DocumentSignType.EConsent
                  ? DOCS_DOCUMENT_LANG.DOCUMENT_ECONSENT_DIALOG_AGREEMENT_ETC_LINK
                  : DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_LINK
              )}
            </a>
            {MvnMessage(DOCS_DOCUMENT_LANG.DOCUMENT_SIGN_DIALOG_AGREEMENT_ETC_SUFFIX)}
          </GrTypography>
        </li>
      </AgreementWrapper>
    </GrDialog>
  );
}

const AgreementWrapper = styled.ul({
  margin: 0,
  display: "flex",
  flexDirection: "column",
  paddingLeft: "20px",
  gap: "8px",

  "& > li > span": {
    wordBreak: "keep-all",
  },
});
